import React, {useEffect, useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import CustomerCard from "./CustomerCard";
import OrderCard from "./OrderCard";
import ShippingAddressCard from "./ShippingAddressCard";
import Products from "./Products";
import SummaryCard from "./SummaryCard";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import {useForm} from "react-hook-form";

export default function () {
  const {control, handleSubmit, watch} = useForm();

  const {id} = useParams();
  const [data, setData] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`/orders/${id}`, {params: {order_history_id: watch('order_history_id')}}).then(res => {
      if (res.data.status === 'success'){
        let historyList = res.data.historyList;
        if (historyList.length){
          historyList.unshift({
            id: "initial_order",
            name: "Initial Order"
          })
        }

        setData(res.data);
      }
    }).catch(err => {
      console.log(err)
      if (err.response.status === 403) {
        navigate('/orders');
      }
    })
  }, [watch('order_history_id')]);

  return (
    <>
      {data?.order && (
        <>
          <div className="row">
            <div className="col-xxl-6 pt-5">
              <div className="card card-flush py-4 flex-row-fluid">
                <div className="card-header">
                  <div className="card-title">
                    <h2>Edit History</h2>
                  </div>
                </div>
                <div className="card-body pt-0">
                  <div className="row mt-5">
                    <ReactSelectInput
                      label='Select Edit History'
                      name={`order_history_id`}
                      control={control}
                      options={data?.historyList}
                    />
                  </div>
                </div>
              </div>
            </div>
            <CustomerCard customer={data.order.user}/>
            <OrderCard data={data} order={data.order}/>
            <ShippingAddressCard address={data.order.shippingAddress}/>
            <Products data={data}/>
            <SummaryCard order={data.order}/>
          </div>
        </>
      )}
    </>
  );
}